const desertA = require("../assets/public/audio/desert.mp3");
const fieldA = require("../assets/public/audio/field.mp3");
const mountainsA = require("../assets/public/audio/mountains.mp3");
const snowA = require("../assets/public/audio/snow.mp3");
const spaceA = require("../assets/public/audio/space.mp3");
const swampA = require("../assets/public/audio/swamp.mp3");

export { desertA, fieldA, mountainsA, snowA, spaceA, swampA };
